import {
  loadNoteReviewRequested,
  noteOverallReviewSubmitted,
  useAppDispatch,
  NoteReview as NoteReviewInterface,
} from '@ax/redux-store';
import { OverallReviewResponse, StateSliceStatus } from '@ax/constants';
import styles from './NoteReview.module.scss';
import ThumbsUp from '@image/ThumbsUp.svg';
import ThumbsDown from '@image/ThumbsDown.svg';
import { Loader } from '@ax/ui';
import { useEffect } from 'react';

export interface NoteReviewProps {
  noteId: string;
  review?: NoteReviewInterface;
  reviewStateStatus: StateSliceStatus;
}

const NoteReview = ({ review, noteId, reviewStateStatus }: NoteReviewProps) => {
  const dispatch = useAppDispatch();
  const isReviewed = !!review?.overallReview;

  useEffect(() => {
    if (dispatch && noteId && reviewStateStatus === StateSliceStatus.Uninitialized) {
      dispatch(loadNoteReviewRequested({ noteId }));
    }
  }, []);

  const handleThumbsUp = () => {
    if (noteId) {
      dispatch(
        noteOverallReviewSubmitted({ overallReview: OverallReviewResponse.THUMBS_UP, noteId }),
      );
    }
  };

  const handleThumbsDown = () => {
    if (noteId) {
      dispatch(
        noteOverallReviewSubmitted({ overallReview: OverallReviewResponse.THUMBS_DOWN, noteId }),
      );
    }
  };

  const handleKeyDownThumbsUp = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleThumbsUp();
    }
  };

  const handleKeyDownThumbsDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleThumbsDown();
    }
  };

  if (reviewStateStatus === StateSliceStatus.Loading) {
    return (
      <div className={styles.loader_container}>
        <Loader />
      </div>
    );
  }

  return (
    <div
      key={`${noteId}-${isReviewed}`}
      className={styles.note_review__container}
    >
      {!isReviewed && <span className={styles.note_review__text}>Rate this note?</span>}

      {isReviewed && <span className={styles.note_review__text}>Thanks for the feedback!</span>}

      {!isReviewed && (
        <>
          <button
            onClick={handleThumbsUp}
            onKeyDown={handleKeyDownThumbsUp}
          >
            <img
              className={styles.img__thumbs__up}
              src={ThumbsUp}
              alt="Thumbs Up"
            />
          </button>
          <button
            onClick={handleThumbsDown}
            onKeyDown={handleKeyDownThumbsDown}
          >
            <img
              className={styles.img__thumbs__down}
              src={ThumbsDown}
              alt="Thumbs Down"
            />
          </button>
        </>
      )}
    </div>
  );
};

export default NoteReview;
